import Route from 'cio/routes/base';
import IntegrationsFormsGeneralController from 'cio/pods/integrations/forms/general/controller';
export default class IntegrationsFormsGeneral extends Route {
  resetController(controller: IntegrationsFormsGeneralController) {
    controller.setDefaults();
  }
}
